import { CSSProperties } from 'react';
import Button from './button';
import Media from './media';
import Richtext from './richtext';

class VideoTile {
  name: string;
  inlineMedia?: Media;
  fullscreenMedia?: Media;
  text?: Richtext;
  cursor?: Button;
  customStyles?: CSSProperties;
  thumbnail?: number;
  textPosition: 'bottom' | 'top';

  constructor(props: any) {
    const {
      name,
      inlineMedia,
      fullscreenMedia,
      text,
      cursor,
      customStyles,
      thumbnail,
      textPosition
    } = props;
    this.name = name;
    this.inlineMedia = inlineMedia ? new Media(inlineMedia) : undefined;
    this.fullscreenMedia = fullscreenMedia
      ? new Media(fullscreenMedia)
      : undefined;
    this.text = text ? new Richtext(text) : undefined;
    this.cursor = cursor ? new Button(cursor) : undefined;
    this.customStyles = customStyles;
    this.thumbnail = thumbnail;
    this.textPosition = textPosition;
  }
}

export default class VideoTiles {
  color?: string;
  videoTiles?: VideoTile[];

  constructor(props: any) {
    const { textColor, videoTilesCollection } = props;
    this.color = textColor;
    this.videoTiles = videoTilesCollection?.items?.map(
      (item: any) => new VideoTile(item)
    );
  }
}
